export default "__VITE_ASSET__Dwx05N5j__"